<div  class="container">
  <div class="content">
    <div class="message-section">
      <svg *ngIf="!successMessage" width="49" height="48" viewBox="0 0 49 48" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="24.5008" cy="23.9998" r="19.2" fill="#0CF0BB" stroke="#0CF0BB" stroke-width="3.6" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M32.1 19.6722L21.8727 29.9034L16.7532 24.7878" stroke="#101223" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
        
      <div class="text-content">
        <div class="h6" *ngIf="!successMessage">We’ve emailed a link to reset your password.</div>
        <div class="h6" *ngIf="successMessage">Need a new link?</div>
        <p class="subtitle" *ngIf="!successMessage">
          If you don’t see it in your inbox, check your spam or promotions
          folder.
        </p>
        <p class="subtitle" *ngIf="successMessage">
          Give it 30 seconds to arrive. You can request a new one if it doesn’t show up.
        </p>
      </div>
    </div>
    <div class="actions">
      <div class="resend-section">
    
        <button class="btn btn-secondary btn-large w100" [ngClass]="{'disabled': loading || isOnCooldown}" (click)="resendEmail()" [disabled]="loading || isOnCooldown">
          <span *ngIf="!loading && !isOnCooldown">Resend Email</span>
          <span *ngIf="loading" class="loader"></span>
          <span *ngIf="isOnCooldown && !loading">Resend Email</span>
        </button>
        <span class="resend-prompt btn btn-tertiary btn-small" (click)="resendEmail()" *ngIf="!successMessage">Didn’t get it?</span>
      </div>
      <p class="support-text p5" *ngIf="!successMessage">
        If you need further assistance, <a href="#" class="dark-link-hover">Contact our support team</a> for help.
      </p>
      <p class="support-text p5" *ngIf="successMessage">
        Still need help? <a href=" https://www.way.com/aboutUs/contactUs" class="dark-link-hover">Contact our support team.</a>
      </p>
    </div>
  </div>
</div>
<div *ngIf="successMessage" class="success-message">
 
</div>
